import React from "react";
import { createUseStyles } from "react-jss";
import Row from "reactstrap/lib/Row";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	headerSet: {
		alignItems: "center",
		marginBottom: "15px",
	},
	header: {
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		textTransform: "uppercase",
		color: theme.palette.colors.darkSlateBlue2,
		letterSpacing: "2.2px",
		marginRight: "15px",
	},
	buttonSet: {
		display: "block",
		justifyContent: "flex-start",
		marginBottom: "50px",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		buttonSet: {
			marginBottom: "30px",
		},
	},
}));

const TagLayout = (props) => {
	const { text } = props;
	const classes = useStyles();

	return (
		<>
			{text && (
				<div className={classes.headerSet}>
					<span className={classes.header}>{text.TAGS}</span>
				</div>
			)}
			<div className={classNames(classes.buttonSet, classes.block)}>{props.children}</div>
		</>
	);
};

export default TagLayout;
